import { axiosInstance } from '../api';


export default function(userId, studyId, { note, status }) {
    return axiosInstance.put(`/api/study/${studyId}/interested/${userId}`, {
        note,
        status,
    });
}